import { Observable, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { DomainError } from './domain-error';
import { HttpErrorParser } from './http-error-parser.utils';

export function handleError(
  error: unknown,
  customMessage?: string,
): Observable<never> {
  if (error instanceof HttpErrorResponse) {
    const domainError = HttpErrorParser.parseHttpError(error);
    return throwError(() => domainError);
  }

  if (error instanceof DomainError) return throwError(() => error);

  const serviceException = HttpErrorParser.parse(error, customMessage);

  return throwError(
    () =>
      new DomainError(
        serviceException.code,
        serviceException.message,
        serviceException.details,
      ),
  );
}
